export default __webpack_public_path__ + "static/media/map.48d4d249.svg";